import { makeStyles, Theme } from "@material-ui/core/styles";
import {
  lightGrey,
  secondary,
} from "../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles<Theme>((theme) => ({
  titleContainer: {
    marginLeft: "22px",
  },
  loaderContainer: {
    marginTop: "40px",
  },
  title: {
    fontSize: "28px",
    lineHeight: "32px",
  },
  subTitle: {
    marginBottom: theme.spacing(1),
  },
  dateLabel: {
    fontSize: "10px",
    color: "#929FAD",
    marginTop: theme.spacing(1),
  },
  headerSeparator: {
    height: "5px",
    width: "100%",
    backgroundColor: lightGrey,
    marginTop: theme.spacing(4),
  },
  infoContainer: {
    position: "relative",
    width: "171px",
    height: "46px",
    backgroundColor: "#CFE2FF",
    borderRadius: "12px",
    marginLeft: "auto",
    padding: "11px 12px 11px 12px",
    cursor: "pointer",
  },
  infoLabel: {
    color: "#0052CC",
    fontSize: "16px",
    fontWeight: 400,
    marginLeft: "12px",
  },
  whyQuestion: {
    fontSize: "12px",
    color: secondary,
    marginLeft: "11px",
    cursor: "pointer",
  },
  tableTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
    fontWeight: 700,
    color: "#929FAD",
  },
  dateRangeContainer: {
    margin: "29px 0px 20px 0px",
    paddingBottom: `${theme.spacing(2)}px`,
    borderBottom: `5px solid ${lightGrey}`,
  },
  symbolsContainer: {
    marginRight: theme.spacing(2),
  },
  greyPoint: {
    borderRadius: 50,
    border: "2px solid #CFDAE5",
    width: "10px",
    height: "10px",
  },
  verticalLine: {
    width: "2px",
    height: "33px",
    backgroundColor: "#CFDAE5",
    margin: "4px 0px 4px 4px",
  },
  dateRowSeparator: {
    width: "100%",
    height: "1px",
    backgroundColor: lightGrey,
    margin: `${theme.spacing(2)}px 0`,
  },
  dateContainer: {
    width: "calc(100% - 26px)",
  },
  dateValue: {
    marginLeft: "auto",
  },
  buttonsContainer: {
    marginTop: theme.spacing(3),
  },
  containerReason: {
    height: "102px",
    borderRadius: "14px",
    backgroundColor: lightGrey,
    padding: `${theme.spacing(3)}px`,
    marginTop: "12px",
  },
  reason: {
    marginTop: "12px",
  },
  textRentingReason: {
    marginBottom: theme.spacing(2),
  },
  buttonRentingReason: {
    marginTop: theme.spacing(4),
  },
  backLabel: {
    color: theme.palette.secondary.main,
    marginLeft: theme.spacing(1),
  },
}));

export default useStyles;
